class FreeShipping extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.updateProgress();
  }

  static get observedAttributes() {
    return ['data-cart-total', 'data-minimum'];
  }

  attributeChangedCallback() {
    this.updateProgress();
  }

  updateProgress() {
    const total = Number(this.dataset.cartTotal || 0);
    const minimum = Number(this.dataset.minimum || 0);

    const remainingText = this.querySelector('.free-shipping--text-remaining');
    const fullText = this.querySelector('.free-shipping--text-full');
    const percentageBar = this.querySelector('.free-shipping--percentage');

    if (!minimum || !percentageBar) return;

    let percentage = Math.round((total / minimum) * 100);

    if (percentage < 0) percentage = 0;
    if (percentage > 100) percentage = 100;

    percentageBar.style.width = `${percentage}%`;

    if (total >= minimum) {
      if (remainingText) remainingText.style.display = 'none';
      if (fullText) fullText.style.display = 'block';
    } else {
      if (remainingText) remainingText.style.display = 'block';
      if (fullText) fullText.style.display = 'none';
    }
  }
}

if (!customElements.get('free-shipping')) {
  customElements.define('free-shipping', FreeShipping);
}